'use client' 
 
import { ErrorPage } from '@/components/pages/ErrorPage/ErrorPage'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
 
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

	const pathName = usePathname();
	const locale = pathName.startsWith('/es') ? 'es' : 'en';

  return (
		<ErrorPage retryFunction={reset} locale={locale} />
  )
}